import { render, staticRenderFns } from "./ViewLogin.vue?vue&type=template&id=2b2c9b94&scoped=true&"
import script from "./ViewLogin.vue?vue&type=script&lang=ts&"
export * from "./ViewLogin.vue?vue&type=script&lang=ts&"
import style0 from "./ViewLogin.vue?vue&type=style&index=0&id=2b2c9b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c9b94",
  null
  
)

export default component.exports